const e = {
  undo: "Kumoa",
  redo: "Tee uudelleen",
  confirm: "Vahvista",
  clear: "Tyhjennä",
  more: "lisää",
  cancel: "Peruuta",
  update: "Päivitä"
}, a = {
  positiveText: "Vahvista",
  negativeText: "Peruuta"
}, t = {
  placeholder: "Valitse",
  loading: "Ladataan"
}, i = {
  clear: "Tyhjennä",
  now: "Nyt",
  confirm: "Vahvista",
  selectTime: "Valitse kellonaika",
  selectDate: "Valitse päivämäärä",
  datePlaceholder: "Valitse päivämäärä",
  datetimePlaceholder: "Valitse päivämäärä ja kellonaika",
  monthPlaceholder: "Valitse kuukausi",
  yearPlaceholder: "Valitse vuosi",
  quarterPlaceholder: "Valitse vuosineljännes",
  startDatePlaceholder: "Alkamispäivä",
  endDatePlaceholder: "Päättymispäivä",
  startDatetimePlaceholder: "Alkamispäivä ja -kellonaika",
  endDatetimePlaceholder: "Päättymispäivä ja -kellonaika",
  startMonthPlaceholder: "Alkamiskuukausi",
  endMonthPlaceholder: "Päättymiskuukausi",
  today: "Tänään"
}, n = {
  checkTableAll: "Valitse kaikki taulukosta",
  uncheckTableAll: "Poista kaikki valinnat taulukosta",
  confirm: "Vahvista",
  clear: "Tyhjennä",
  apply: "Käytä",
  filters: "Suodattimet",
  sort: "Järjestä"
}, l = {
  sourceTitle: "Lähde",
  targetTitle: "Kohde"
}, o = {
  selectAll: "Valitse kaikki",
  unselectAll: "Poista kaikki valinnat",
  clearAll: "Tyhjennä"
}, r = {
  description: "Ei dataa"
}, s = {
  placeholder: "Valitse"
}, c = {
  placeholder: "Valitse kellonaika",
  positiveText: "OK",
  negativeText: "Peruuta",
  now: "Nyt"
}, u = {
  goto: "Siirry",
  selectionSuffix: "sivulle",
  next: "Seuraava",
  previous: "Edellinen"
}, d = {
  add: "Lisää"
}, k = {
  loading: "Ladataan"
}, m = {
  placeholder: "Lisää"
}, p = {
  placeholder: "Lisää"
}, h = {
  create: "Luo"
}, v = {
  title: "Teemaeditori",
  clearAllVars: "Tyhjennä kaikki muuttujat",
  clearSearch: "Tyhjennä haku",
  filterCompName: "Suodata komponentin nimellä",
  filterVarName: "Suodata muuttujan nimellä",
  import: "Tuo",
  export: "Vie",
  restore: "Palauta oletusarvo"
}, P = {
  tipPrevious: "Edellinen kuva (←)",
  tipNext: "Seuraava kuva (→)",
  tipCounterclockwise: "Vastapäivään",
  tipClockwise: "Myötäpäivään",
  tipZoomOut: "Loitonna",
  tipZoomIn: "Lähennä",
  tipClose: "Sulje (Esc)",
  tipOriginalSize: "Palauta alkuperäiseen kokoon"
}, y = {
  heading: "Järjestäminen ja suodattimet",
  sortHeading: "Järjestysperuste",
  newestFirst: "Uusin ensin",
  oldestFirst: "Vanhin ensin",
  ascending: "Nous.",
  descending: "Lask.",
  apply: "Käytä",
  clear: "Tyhjennä",
  cancel: "Peruuta",
  filters: "Suodattimet"
}, T = {
  noMatchingFound: "Tuloksia ei löytynyt"
}, g = {
  margin: "Marginaali",
  padding: "Reunatila",
  reset: "Nollaa",
  errorMsg: "Annettu arvo on virheellinen."
}, V = {
  brandColors: "Brändivärit",
  noBrandColors: "Brändivärejä ei ole vielä lisätty.",
  getStarted: "Aloita",
  add: "Lisää",
  default: "Oletus"
}, j = {
  addColor: "Lisää uusi väri",
  editColor: "Muokkaa väriä",
  add: "Lisää",
  noData: "Värejä ei ole vielä lisätty.",
  invalidCode: "Virheellinen värikoodi",
  defaultColor: "Oletusvärit"
}, f = {
  global: e,
  Popconfirm: a,
  Cascader: t,
  DatePicker: i,
  DataTable: n,
  LegacyTransfer: l,
  Transfer: o,
  Empty: r,
  Select: s,
  TimePicker: c,
  Pagination: u,
  DynamicTags: d,
  Log: k,
  Input: m,
  InputNumber: p,
  DynamicInput: h,
  ThemeEditor: v,
  Image: P,
  SortFilter: y,
  IconPicker: T,
  Spacing: g,
  BrandColorPicker: V,
  BrandBoard: j
};
export {
  j as BrandBoard,
  V as BrandColorPicker,
  t as Cascader,
  n as DataTable,
  i as DatePicker,
  h as DynamicInput,
  d as DynamicTags,
  r as Empty,
  T as IconPicker,
  P as Image,
  m as Input,
  p as InputNumber,
  l as LegacyTransfer,
  k as Log,
  u as Pagination,
  a as Popconfirm,
  s as Select,
  y as SortFilter,
  g as Spacing,
  v as ThemeEditor,
  c as TimePicker,
  o as Transfer,
  f as default,
  e as global
};
